module.exports = __webpack_public_path__ + "static/media/aspen-place.8cf5e9c6.pdf";